module.exports = __webpack_public_path__ + "static/media/shape_M.7b8d2521.glb";